<template>
    <div class="main" style="background-color: #FFFFFF">
        <Steps direction="horizontal" :current="current">
            <Step v-for="(item,index) in stepList" :key="index" :title="item.title" :icon="item.icon" @click.native="changeActive(index)"></Step>
        </Steps>
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="180" class="form">
            <div class="top" v-show="current==0">
                <div class="content">
                    <FormItem label="申请人姓名：" prop="linkmanName">
                        <Input placeholder="请输入申请人姓名" v-model="formValidate.linkmanName"></Input>
                    </FormItem>
                    <FormItem label="证件类型：" prop="linkmanCredential">
                        <Select placeholder="请选择证件类型" v-model="formValidate.linkmanCredential">
                            <Option v-for="(item,index) in typeList" :value="item.value" :key="index">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="证件号码：" prop="linkmanCredentialNo">
                        <Input placeholder="请输入证件号码" v-model="formValidate.linkmanCredentialNo"></Input>
                    </FormItem>
                    <FormItem label="手机号码：" prop="mobile">
                        <Input placeholder="请输入手机号码" v-model="formValidate.mobile"></Input>
                        <Button type="primary" @click="sendCode" size="small">发送验证码</Button>
                    </FormItem>
                    <FormItem label="验证码：" prop="verifyCode">
                        <Input placeholder="请输入验证码" v-model="formValidate.verifyCode"></Input>
                    </FormItem>
                    <FormItem label="联系电话：" prop="phone">
                        <Input placeholder="请输入联系电话" v-model="formValidate.phone"></Input>
                    </FormItem>
                    <FormItem label="联系地址：" style="width: 100%" prop="address">
                        <Select @on-change="changePro" size="large" style="width:33.3%" placeholder="请选择省" v-model="formValidate.province">
                            <Option v-for="(item,index) in provinceList" :value="item.id" :key="index">{{ item.name }}</Option>
                        </Select>
                        <Select @on-change="changeCity" size="large" style="width:33.3%" placeholder="请选择市" v-model="formValidate.city">
                            <Option v-for="(item,index) in cityList" :value="item.id" :key="index">{{ item.name }}</Option>
                        </Select>
                        <Select size="large" style="width:33.3%" placeholder="请选择区" v-model="formValidate.address">
                            <Option v-for="(item,index) in areaList" :value="item.id" :key="index">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="详细地址：" prop="addressDetail">
                        <Input placeholder="请输入详细地址" v-model="formValidate.addressDetail"></Input>
                    </FormItem>
                </div>
            </div>
            <div class="top" v-show="current==1">
                <div class="deadAdd" v-for="(d,i) in formValidate.users" :key="i">
                    <div>海葬者信息填写<span v-if="i != 0">{{i+1}}</span></div>
                    <div class="content">
                        <FormItem label="海葬者姓名：" :prop="'users.' + i + '.name'" :rules="{required: true, message: '逝者姓名不能为空', trigger: 'blur'}">
                            <Input placeholder="请输入姓名" v-model="d.name"></Input>
                        </FormItem>
                        <FormItem label="海葬者年龄：" :prop="'users.' + i + '.age'" :rules="{ pattern: /^(?:[1-9][0-9]?|1[01][0-9]|120)$/, message: '年龄只能是大于0的数字并且不能超过120', trigger: 'blur'}">
                            <Input placeholder="请输入年龄" type="text" v-model="d.age" number></Input>
                        </FormItem>
                        <FormItem label="海葬者性别：" :prop="'users.' + i + '.sex'" :rules="{ required: true, message: '请选择性别', trigger: 'change'}">
                            <RadioGroup  v-model="d.sex" >
                                <Radio size="large" style="width: 100px"  :label="item.value" :key="index" v-for="(item,index) in commData.sex">
                                    <span>{{item.name}}</span>
                                </Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="与申请人关系：" :prop="'users.' + i + '.relation'" :rules="{ required: true, message: '请选择与申请人关系', trigger: 'change'}">
                            <Select placeholder="请选择与申请人关系" v-model="d.relation">
                                <Option v-for="(item,index) in commData.relation" :value="item.value" :key="index">{{ item.name }}</Option>
                            </Select>
                        </FormItem>
                        <FormItem label="证件类型：" :prop="'users.' + i + '.credential'" :rules="{ required: true, message: '请选择证件类型', trigger: 'change'}">
                            <Select placeholder="请选择证件类型" v-model="d.credential">
                                <Option v-for="(item,index) in commData.credential" :value="item.value" :key="index">{{ item.name }}</Option>
                            </Select>
                        </FormItem>
                        <FormItem label="证件号码：" :prop="'users.' + i + '.credentialNo'" :rules="{ required: true, message: '证件号码不能为空', trigger: 'blur'}">
                            <Input placeholder="请输入证件号码" type="text" v-model="d.credentialNo"></Input>
                        </FormItem>
                        <FormItem label="户籍：" style="width: 100%" :prop="'users.' + i + '.domicile'" :rules="{ required: true, message: '请选择户籍', trigger: 'change'}">
                            <Select @on-change="changeDomPro(i,$event)" size="large" style="width:33.3%" placeholder="请选择省" v-model="d.province">
                                <Option v-for="(item,index) in provinceList" :value="item.id" :key="index">{{ item.name }}</Option>
                            </Select>
                            <Select @on-change="changeDomCity(i,$event)" size="large" style="width:33.3%" placeholder="请选择市" v-model="d.city">
                                <Option v-for="(item,index) in d.cityList" :value="item.id" :key="index">{{ item.name }}</Option>
                            </Select>
                            <Select size="large" style="width:33.3%" placeholder="请选择区" v-model="d.domicile">
                                <Option v-for="(item,index) in d.areaList" :value="item.id" :key="index">{{ item.name }}</Option>
                            </Select>
                        </FormItem>
                        <FormItem label="骨灰寄存处：" :prop="'users.' + i + '.deposit'" :rules="{ required: true, message: '请选择骨灰寄存处', trigger: 'change'}">
                            <Select placeholder="请选择骨灰寄存处" v-model="d.deposit">
                                <Option v-for="(item,index) in commData.deposit" :value="item.value" :key="index">{{ item.name }}</Option>
                            </Select>
                        </FormItem>
                        <FormItem label="职业：" :prop="'users.' + i + '.profession'" :rules="{ required: true, message: '请输入职业', trigger: 'blur'}">
                            <Input placeholder="请输入职业" type="text" v-model="d.profession"></Input>
                        </FormItem>
                        <FormItem label="出生日期：" :prop="'users.' + i + '.birthDate'" :rules="{ required: true, type: 'date', message: '请选择出生日期', trigger: 'change'}">
                            <DatePicker type="date" v-model="d.birthDate" placeholder="请选择出生日期" style="width: 100%" size="large"></DatePicker>
                        </FormItem>
                        <FormItem label="逝世日期：" :prop="'users.' + i + '.deathDate'" :rules="{ required: true, type: 'date', message: '请选择逝世日期', trigger: 'change'}">
                            <DatePicker type="date" v-model="d.deathDate" placeholder="请选择逝世日期" style="width: 100%" size="large"></DatePicker>
                        </FormItem>
                    </div>
                </div>
            </div>
            <div class="top" v-show="current==2">
                <div class="content">
                    <FormItem label="海葬参加地点：" prop="position">
                        <Select @on-change="changePosi" placeholder="请选择参加地点" v-model="formValidate.position">
                            <Option v-for="(item,index) in positionList" :value="item.value" :key="index">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="海葬参加年份：" prop="year">
                        <Select @on-change="changeYear" @on-open-change="openYear" placeholder="请选择参加年份" v-model="formValidate.year">
                            <Option v-for="(item,index) in yearList" :value="item.value" :key="index">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="海葬参加月份：" prop="month">
                        <Select placeholder="请选择参加月份" @on-open-change="openMonth" v-model="formValidate.month">
                            <Option v-for="(item,index) in monthList" :value="item.value" :key="index">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="参加活动人数：" prop="participantNum">
                        <Input placeholder="请输入参加活动人数" type="text" v-model="formValidate.participantNum" number></Input>
                    </FormItem>
                </div>
            </div>
            <div class="top" v-show="current==3">
                <div class="content" v-for="(item,index) in fileTypeList" :key="index">


                    <div class="grace-idcard-text">
                        {{item.name}}
                    </div>
                    <div class="grace-idcard-items">
                        <uploadFiles ref='files' type="1" @updateTotalImgList="updateImgList($event,item.value)"></uploadFiles>
                        <div class="grace-idcard-preview">
                            <img :src="encodeURI(imgs[index].src)">
                        </div>
                    </div>
                </div>
            </div>
            <Button type="primary" ghost @click="add" class="next" style="margin-right: 20px" size="large" v-if="current == 1">添加逝者信息</Button>
            <Button type="primary" @click="next" class="next" size="large" v-if="current != 3">下一步</Button>
            <Button type="primary" @click="save('formValidate')" class="next" size="large" v-if="current == 3">保存</Button>
        </Form>
        <login-modal ref="login" @toRegister="openModal('register')" @toResetPwd="openModal('resetPwd')" :mask-closable="false" @closeModal="closeModal('login')" ></login-modal>
        <register-modal ref="register" @toLogin="openModal('login')" @closeModal="closeModal('register')" ></register-modal>
        <reset-pwd-modal ref="resetPwd"  @toLogin="openModal('login')" @closeModal="closeModal('resetPwd')" ></reset-pwd-modal>
    </div>
</template>

<script>
    var self;
    import api from '@/api/api'
    import uploadFiles from '../../components/uploadFiles1'
    import  util from '../../utils/util'
    import {mapState} from 'vuex'
    import loginModal from "../../components/header/loginModal";
    import registerModal from "../../components/header/registerModal";
    import resetPwdModal from "../../components/header/resetPwdModal";

    export default {
        name: "order",
        components: {
            uploadFiles,
            loginModal,
            registerModal,
            resetPwdModal
        },
        data(){
            return{
                userAreaList:[],
                userCityList: [],
                commData: [],   // 基本数据（证件类型、骨灰寄存处、文件类型、活动地点、与申请人关系、性别）
                imgs:[],
                arrImgs:[], // 暂存上传的url
                fileTypeList:'',    // 文件类型
                current: 0,
                sexList: [{
                    name: '男',
                    value: '1'
                },{
                    name: '女',
                    value: '0'
                }],    // 性别
                formValidate: {
                    source:'2', // 数据来源
                    users: [{ // 逝者信息
                        name: '', // 逝者姓名
                        age: '', // 逝者年龄
                        sex: '', // 逝者性别
                        credential: '',	// 证件类型
                        credentialNo: '',	// 证件号码
                        deposit: '', // 逝者骨灰寄存处
                        relation: '',	// 逝者与申请人关系
                        domicile: '',	// 户籍
                        profession: '',		// 职业
                        birthDate: '',	// 出生日期
                        deathDate: '',	// 逝世日期
                        province: '',   // 省
                        city: '',   // 市
                        cityList: [],
                        areaList: [],
                    }],
                    position: '',   // 预约地点
                    year: null,   // 预约年
                    month: null,  // 预约月
                    participantNum: '', // 参加人数
                    linkmanName :'',
                    linkmanCredential:'',
                    linkmanCredentialNo:'',
                    mobile:'',
                    phone:'',
                    address:'',
                    addressDetail:'',
                    files:[],
                },
                ruleValidate: {
                    linkmanName: [  /*申请人*/
                        { required: true, message: '申请人姓名不能为空', trigger: 'blur'}
                    ],
                    linkmanCredential: [  /*证件类型*/
                        { required: true, message: '请选择证件类型', trigger: 'change'}
                    ],
                    linkmanCredentialNo: [    /*证件号码*/
                        { required: true, message: '证件号码不能为空', trigger: 'blur'},
                        { type: 'string', pattern:  /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '证件号码格式错误', trigger: 'blur'}
                    ],
                    mobile: [ /*手机号码*/
                        { required: true, message: '手机号码不能为空', trigger: 'blur'},
                        { type:'string', pattern: '0?(13|14|15|18|17)[0-9]{9}', message: '手机号码格式错误', trigger: 'blur'}
                    ],
                    phone: [  /*电话号码*/
                        { type: 'string', pattern: /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/, message: '电话号码格式错误', trigger: 'blur'},
                    ],
                    address: [  /*地区编码*/
                        { required: true, message: '请选择联系地址', trigger: 'change'}
                    ],
                    addressDetail: [ /*详细地址*/
                        { required: true, message: '详细地址不能为空', trigger: 'blur'},
                    ],
                    deadName: [ /*逝者姓名*/
                        { required: true, message: '逝者姓名不能为空', trigger: 'blur'},
                    ],
                    age: [  /*年龄*/
                        { pattern: /^(?:[1-9][0-9]?|1[01][0-9]|120)$/, message: '年龄只能是大于0的数字并且不能超过120', trigger: 'blur'}
                    ],
                    sex: [  /*性别*/
                        { required: true, message: '请选择性别', trigger: 'change'}
                    ],
                    deposit: [   /*骨灰寄存处*/
                        { required: true, message: '请选择骨灰寄存处', trigger: 'change'}
                    ],
                    position: [   /*活动地点*/
                        { required: true, message: '请选择活动地点', trigger: 'change'}
                    ],
                    year: [ /*活动年份*/
                        { required: true, message: '请选择活动年份', trigger: 'change'}
                    ],
                    month: [    /*活动月份*/
                        { required: true, message: '请选择活动月份', trigger: 'change'}
                    ],
                    participantNum: [   /*活动人数*/
                        { required: true, type: 'number', message: '参加活动人数不能为空并且只能是大于0的数字', trigger: 'blur'}
                    ],
                },
                areaList: '',   // 区
                area: '',
                provinceList: '',   // 省
                province: '',
                cityList: '',   // 市
                city: '',
                positionList:'',    // 参加地点
                position: '',
                yearList: '',   // 参加年份
                year: '',
                monthList: '',  // 参加月份
                month: '',
                typeList: '',   // 证件类型
                stepList: [{
                    title: '填写申请人信息',
                    icon: 'md-person'
                },{
                    title: '填写逝者信息',
                    icon: 'ios-person'
                },{
                    title: '预约信息',
                    icon: 'ios-create'
                },{
                    title: '上传证件',
                    icon: 'md-cloud-upload'
                }],
                depositList: '',   // 骨灰寄存
            }
        },
        mounted() {
            self = this;
        },
        activated(){
            let checkToken = util.checkToken(this.$store)
            if (checkToken == false) {
                this.$refs['login'].open()
                return;
            }
            this.getArea();
            this.getCommon();

            this.initPluginForm();
        },
        computed:{
            ...mapState(['token'])
        },
        methods:{
            closeModalAll(){
                for(let i in this.$refs){
                    setTimeout(function () {
                        self.$refs[i].hide()
                    },80)
                }
            },
            closeModal(key){
                console.log('closeModal,',key)
                // this.plugin.modal[key].fade = false
                this.$refs[key].hide()
            },
            openModal(key){
                this.closeModalAll()
                // console.log('openModal,',key)
                // this.plugin.modal[key].fade = true
                setTimeout(function () {
                    self.$refs[key].open()
                },300)
            },
            initPluginForm(){
                this.idCard1 = require('../../assets/imgs/idcard1.png');
                this.idCard2 = require('../../assets/imgs/idcard2.png');
                // this.$refs.files.clearAllImg()
            },
            updateImgList(items,type){
                if(items.length==0){
                    this.idCard1 = this.idCard1;
                }else {
                    this.$Message.success('上传成功');
                    items.forEach(function (item) {
                        for (let i = 0; i < self.imgs.length; i++) {
                            if (type == self.imgs[i].value) {
                                self.imgs[i].src = item.url
                            }
                        }
                        self.arrImgs.push({
                            name:item.name,
                            size:item.size,
                            id:item.id,
                            url:item.url,
                            type:type
                        })
                    })
                }
            },

            getArea(){
                api.getAreaData({"pId":''}).then(res => {
                    this.provinceList = res;
                });
            },
            // 获取预约基本数据（性别、证件类型、骨灰寄存、活动地点）
            getCommon() {
                api.getCommonData().then(res => {
                    if (res == null) return;
                    this.commData = res;
                    this.typeList = res.credential;
                    this.sexList = res.sex;
                    this.depositList = res.deposit;
                    this.positionList = res.position;
                    this.fileTypeList = res.fileType;
                    for(let i = 0; i < this.fileTypeList.length; i++) {
                        this.imgs.push({
                            src:this.fileTypeList[i].remark,
                            value:this.fileTypeList[i].value
                        });
                    }
                })
            },
            // 步骤切换
            changeActive(index) {
              this.current = index;
            },
            // 下一步
            next () {
                if (this.current == 3 ) {
                    return;
                } else {
                    this.current += 1;
                }
            },
            // 添加多条逝者信息
            add () {
                this.formValidate.users.push({
                    name: '',
                    age: '',
                    sex: '',
                    credential: '',
                    credentialNo: '',
                    deposit: '',
                    relation: '',
                    domicile: '',
                    profession: '',
                    birthDate: '',
                    deathDate: '',
                    province: '',
                    city: '',
                    cityList: [],
                    areaList: []
                });
            },
            // 预约保存
            save(form){
                console.log(JSON.stringify(form))
                let checkToken = util.checkToken(this.$store)
                if (checkToken == false) {
                    this.$Message.info("请先登录，再预约");
                    return;
                }
                for (let i = 0; i < this.arrImgs.length; i++) {
                    if (this.arrImgs[i].url == self.imgs[i].src && this.arrImgs[i].type == self.imgs[i].value) {
                        self.formValidate.files.push({
                            fileId: this.arrImgs[i].id,
                            fileType: this.arrImgs[i].type,
                            location: this.arrImgs[i].url,
                            name: this.arrImgs[i].name,
                            size: this.arrImgs[i].size
                        });
                    }
                }
                console.log(JSON.stringify(self.formValidate.files))
                if(this.formValidate.files.length == 0){
                    this.$Message.info("请上传相关证件");
                    return;
                }
                var paramters = {
                    "source":"2",
                    "year":this.formValidate.year,
                    "month":this.formValidate.month,
                    "position":this.formValidate.position,
                    "participantNum": this.formValidate.participantNum,
                    "linkmanName":this.formValidate.linkmanName,
                    "linkmanCredential":this.formValidate.linkmanCredential,
                    "linkmanCredentialNo":this.formValidate.linkmanCredentialNo,
                    "mobile":this.formValidate.mobile,
                    "phone":this.formValidate.phone,
                    "address":this.formValidate.address,
                    "addressDetail":this.formValidate.addressDetail,
                    "users":this.formValidate.users,
                    "files":this.formValidate.files
                }
                this.$refs[form].validate((valid) => {
                    if (valid) {
                        api.saveBusiness(this.formValidate).then(res => {
                            this.$Message.success('预约成功');
                            this.formValidate.files = '';
                            this.formValidate.province = '';
                            this.formValidate.city = '';
                            this.formValidate.areaCode = '';
                            this.formValidate.address = '';
                            this.formValidate.sex = '';
                            this.$refs[form].resetFields();
                            this.toInfo(res.id)
                        }).catch(error => {
                            this.$Message.error(error.info);
                        })
                    } else {
                        this.$Message.info('返回看看是否还有未填的信息')
                        return;
                    }
                })
            },
            // 预约基本信息
            toInfo(id){
                this.$router.push({name:'orderInfo',params:{id:id}})
            },
            changePro(val){
                this.province = val;
                api.getAreaData({"pId":val}).then(res => {
                    this.cityList = res;
                });
            },
            changeCity(val){
                this.city = val;
                api.getAreaData({"pId":val}).then(res => {
                    this.areaList = res;
                })
            },
            changeDomPro(i,e){
                for (let j = 0; j < this.formValidate.users.length; j++) {
                    if (i == j) {
                        this.formValidate.users[j].province = e
                        api.getAreaData({"pId":e}).then(res => {
                            this.formValidate.users[j].cityList = res;
                        });
                    }
                }
            },
            changeDomCity(i,e){
                for (let j = 0; j < this.formValidate.users.length; j++) {
                    if (i == j) {
                        this.formValidate.users[j].city = e
                        api.getAreaData({"pId":e}).then(res => {
                            this.formValidate.users[j].areaList = res;
                        });
                    }
                }
            },
            changePosi(val){
                this.position = val;
                api.getYear({"position":val}).then(res => {
                    this.yearList = res;
                })
            },
            openYear(){
                if (this.position == '' || this.position == null) {
                    this.$Message.info('请先选择参加地点')
                    return
                }
                if ((this.position != '' || this.position != null) && (this.yearList == '' || this.yearList == null)) {
                    this.$Message.info('暂无数据，换个地点试试看吧')
                    return;
                }
            },
            openMonth(){
                if (this.position == '' || this.position == null) {
                    this.$Message.info('请先选择参加地点')
                    return
                } else if (this.year == '' || this.year == null) {
                    this.$Message.info('请先选择参加年份')
                    return
                }
            },
            changeYear(val){
                this.year = val;
                api.getMonth({"position":this.position,"year":val}).then(res => {
                    this.monthList = res;
                })
            },
            sendCode(){
                api.sendCode({"phone":this.formValidate.mobile}).then(res => {
                }).catch(error => {
                    this.$Message.error(error.info);
                })
            }
        },
    }
</script>

<style lang="scss">
    .grace-idcard-desc{line-height:2em; background:#FFFFFF; padding:10px; border-radius:5px;}
    .grace-idcard-text{line-height:2em; margin-top:15px;}
    .grace-idcard-items{background:#FFFFFF; padding:15px 0; display:flex; margin:15px 0; border-radius:5px; align-items: flex-start;}
    .grace-idcard-uper-btn:hover{cursor: pointer;}
    .grace-idcard-uper-btn{width:50%; padding: 10px 0; background:#F1F1F1;border-radius:5px; text-align:center;}
    .grace-idcard-uper-btn .img{width:100px;margin:0 auto;}
    .grace-idcard-uper-btn .img img{width:100%;}
    .grace-idcard-uper-btn .change{margin-top:5px; text-align:center;}
    .grace-idcard-preview{width:50%; margin: 0px auto;}
    .grace-idcard-preview img{max-width:100%;}

    .main {
        .ivu-upload-select {
            display: block;
        }
        .ivu-steps-item.ivu-steps-custom .ivu-steps-head-inner>.ivu-steps-icon {
            font-size: 30px!important;
            top: -3px!important;
            right: 4px;
        }
        .ivu-form-item {
            margin: 30px 0px!important;
        }

        .ivu-steps .ivu-steps-title {
            font-size: 18px!important;
        }
        .ivu-steps .ivu-steps-title:hover {
            cursor: pointer;
        }
        .ivu-form .ivu-form-item-label {
            font-size: 17px!important;
        }
        width: 1200px;
        height: auto;
        margin: 0 auto;
        padding-top: 60px;
        @media (max-width:1440px) {
            width: 1024px;
        }
        .form {
            width: 100%;
            height: auto;
            margin: 10% auto 0px;
            .top {
                width: 100%;
                padding: 0px 20%;
                font-size: 20px!important;
            }
        }
        .next {
            width: 20%;
            height: 50px;
            margin: 5% 0px;
            font-size: 20px;
            font-weight: 500;
        }
    }
</style>
